<template>
  <div class="callout warning-callout" :class="type">
    <p v-if="title" class="warning-callout__title">
      <fluent-icon :icon="resolvedIcon" size="16" />
      <span>{{ title }}</span>
    </p>
    <slot />
  </div>
</template>

<script>
// Aviso en línea para formularios: título opcional con icono y cuerpo libre en el slot.
// `type` toma las variantes del callout de Foundation (warning, primary, secondary, alert).
// El icono va con el tipo salvo que se pase uno explícito.
const ICONS_BY_TYPE = {
  warning: 'warning',
  alert: 'dismiss-circle',
  primary: 'info',
  secondary: 'info',
};

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'warning',
    },
  },
  computed: {
    // Icono explícito, o el que corresponde al tipo del aviso.
    resolvedIcon() {
      return this.icon || ICONS_BY_TYPE[this.type] || ICONS_BY_TYPE.warning;
    },
  },
};
</script>

<style scoped lang="scss">
.warning-callout {
  font-size: var(--font-size-small);
  margin-bottom: var(--space-normal);

  &.warning {
    color: var(--y-800);
  }

  &.primary {
    color: var(--w-800);
  }

  // Los párrafos del slot pertenecen al padre; se alcanzan con ::v-deep.
  ::v-deep p {
    margin-bottom: var(--space-smaller);
  }

  &__title {
    align-items: center;
    display: flex;
    font-weight: var(--font-weight-medium);
    gap: var(--space-smaller);
  }
}
</style>
